import React from 'react';
import { FlexibleXYPlot, LineSeries } from 'react-vis';
import Theme from '../../themes';
const getYDomain = (maxValue) => [0, maxValue || 1];
const LineChart = React.memo(({ prevData, currentData, length = 24 }) => {
    const dashedLineLength = length - currentData.length;
    const maxValue = currentData.length > 0
        ? Math.max(...[...prevData, ...currentData].map(d => d.y))
        : 1;
    const generateDashedLineData = () => {
        return new Array(dashedLineLength)
            .fill(undefined)
            .map((_, index) => ({ x: currentData.length + index, y: 0 }));
    };
    return (React.createElement(FlexibleXYPlot, { yDomain: getYDomain(maxValue), margin: { left: 2, right: 2, bottom: 2, top: 2 } },
        prevData.length > 0 && (
        // @ts-ignore
        React.createElement(LineSeries, { color: Theme.colors.PRIMARY_400, 
            // @ts-ignore
            strokeWidth: Theme.lineChart.types.PREV_LINE.strokeWidth, style: { fill: 'none' }, data: prevData.concat({ x: prevData.length, y: 0 }) })),
        currentData.length > 0 && (
        // @ts-ignore
        React.createElement(LineSeries, { color: Theme.colors.PRIMARY_600, 
            // @ts-ignore
            strokeWidth: Theme.lineChart.types.CURRENT_LINE.strokeWidth, style: { fill: 'none' }, data: currentData.concat({
                x: currentData.length,
                y: 0,
            }) })),
        dashedLineLength > 0 && (
        // @ts-ignore
        React.createElement(LineSeries, { color: Theme.colors.INK_200, 
            // @ts-ignore
            strokeWidth: Theme.lineChart.types.DASHED_LINE.strokeWidth, strokeStyle: "dashed", style: { strokeLinecap: 'round', strokeDasharray: '0, 6' }, data: generateDashedLineData() }))));
});
export default LineChart;
//# sourceMappingURL=index.js.map